/* this file is transformed by vux-loader */
/* eslint-disable */
import _slicedToArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";

/* eslint-disable */
import axios from 'axios';
import { mobilePush } from '../api';
import router from '../router';

(function (window, document) {
  var noop = function noop(e) {
    return e;
  };

  var Devices = /*#__PURE__*/function () {
    // Android  Browser iOS   Wx
    function Devices() {
      var _this = this;

      _classCallCheck(this, Devices);

      _defineProperty(this, "property", [{
        name: 'biz.ding.post',
        info: ['钉钉消息'],
        fn: this.post.bind(this)
      }, {
        name: 'biz.util',
        info: ['扫码', '打开新页面', '上传图片', '分享'],
        fn: new Util()
      }, {
        name: 'biz.map',
        info: ['初始化'],
        fn: new MapLocation()
      }, {
        name: 'device.geolocation.get',
        info: ['定位'],
        fn: this.getLocation.bind(this)
      }, {
        name: 'device.base.getUUID',
        info: ['设备UUID'],
        fn: function fn(_ref) {
          var onSuccess = _ref.onSuccess,
              onFail = _ref.onFail;
          return _this.UUID ? onSuccess({
            uuid: _this.UUID
          }) : onFail('ID获取失败');
        }
      }, {
        name: 'biz.cspace.saveFile',
        info: ['下载'],
        fn: this.download.bind(this)
      }, {
        name: 'device.notification.actionSheet',
        info: ['生成下载'],
        fn: function fn(_ref2) {
          var onSuccess = _ref2.onSuccess;
          onSuccess({
            buttonIndex: 0
          });
        }
      }, {
        name: 'biz.navigation.setTitle',
        info: ['设置标题头'],
        fn: function fn(_ref3) {
          var title = _ref3.title;
          document.getElementById('AppTitle') && (document.getElementById('AppTitle').innerText = title);
        }
      }, {
        name: 'ui.pullToRefresh.disable',
        info: ['nouse'],
        fn: noop
      }, {
        name: 'ui.webViewBounce.disable',
        info: ['nouse'],
        fn: noop
      }, {
        name: 'biz.telephone.call',
        info: ['nouse'],
        fn: noop
      }, {
        name: 'biz.telephone.showCallMenu',
        info: ['打开拨号界面'],
        fn: function fn(_ref4) {
          var phoneNumber = _ref4.phoneNumber,
              code = _ref4.code;

          if (_this.platform === 'Android') {
            var a = document.createElement('a');
            a.href = "tel:".concat(code).concat(phoneNumber);
            a.click();
          } else {
            window.plugins.launcher.launch({
              uri: "tel:".concat(code).concat(phoneNumber)
            }, function (e) {
              return console.log(e);
            }, function (e) {
              return console.error(e);
            });
          }
        }
      }, {
        name: 'runtime.permission.requestOperateAuthCode',
        info: ['获取授权code'],
        fn: function fn(e) {
          return e.onSuccess(e);
        }
      }]);

      _defineProperty(this, "version", '1.0');

      _defineProperty(this, "platform", 'Browser');

      _defineProperty(this, "UUID", '');

      _defineProperty(this, "networkState", '');

      document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);

      var deepSet = function deepSet(str, obj, value) {
        var arr = str.split('.');
        arr.reduce(function (t, v, i) {
          return t[v] = typeof t[v] !== 'undefined' ? t[v] : i === arr.length - 1 ? value : {};
        }, obj);
        return obj;
      };

      this.property.forEach(function (v) {
        deepSet(v.name, _this, v.fn);
      });
    }

    _createClass(Devices, [{
      key: "onDeviceReady",
      value: function onDeviceReady() {
        try {
          // 隐藏首屏
          navigator.splashscreen.hide(); // 设备信息

          this.platform = device.platform || 'Android';
          this.UUID = device.uuid;
          this.devices = device; // app 双击退出

          document.addEventListener('backbutton', eventBackButton, false);
          var startTime = 0,
              endTime = 0; // 初始化JPUSH

          this.jpush = new JpushClass();

          if (this.platform === 'iOS') {
            // fix ios webview input cause view bug
            Keyboard.automaticScrollToTopOnHiding = true;
            window.JPush.setApplicationIconBadgeNumber(0);
          } else {
            if (window.JPush.setBadgeNumber) {
              window.JPush.setBadgeNumber(0);
            }
          }

          function eventBackButton() {
            endTime = new Date().getTime();

            if (endTime - startTime < 200) {
              navigator.app.exitApp();
            } else {
              startTime = new Date().getTime();
            }
          }
        } catch (error) {
          alert(error);
          console.log(error);
        }
      }
    }, {
      key: "post",
      value: function post(_ref5) {
        var alias = _ref5.alias,
            content = _ref5.content,
            onSuccess = _ref5.onSuccess,
            onFail = _ref5.onFail;
        return mobilePush({
          alias: alias,
          content: content
        }).then(function (r) {
          return onSuccess(r);
        }).catch(function (e) {
          return onFail(e);
        });
      }
    }, {
      key: "download",
      value: function download(_ref6) {
        var _this2 = this;

        var url = _ref6.url,
            _ref6$processCallBack = _ref6.processCallBack,
            processCallBack = _ref6$processCallBack === void 0 ? noop : _ref6$processCallBack,
            onSuccess = _ref6.onSuccess,
            onFail = _ref6.onFail,
            dir = _ref6.dir;
        return new Promise(function (reslove, reject) {
          if (_this2.platform === 'iOS') {
            return devices.biz.util.openLink({
              url: url,
              onSuccess: onSuccess,
              onFail: onFail
            });
          }

          var dirName = dir || (_this2.platform === 'iOS' ? cordova.file.documentsDirectory : cordova.file.externalRootDirectory);
          var encodeUrl = encodeURI(url);
          var fileName = url.slice(url.lastIndexOf('/') + 1);

          var success = function success(res) {
            onSuccess && onSuccess(res);
            reslove(res);
          };

          var fail = function fail(err) {
            onFail && onFail(err);
            reject(err);
          };

          var downLoadFile = function downLoadFile(fileEntry) {
            var fileTransfer = new FileTransfer();

            fileTransfer.onprogress = function (progressEvent) {
              if (progressEvent.lengthComputable) {
                processCallBack(progressEvent.loaded / progressEvent.total * 100);
              }
            };

            var target = decodeURI(fileEntry.toURL());
            fileTransfer.download(encodeUrl, target, success, fail, false, {});
          };

          var callback = function callback(fs) {
            return fs.getFile(fileName, {
              create: true,
              exclusive: false
            }, downLoadFile, fail);
          };

          window.resolveLocalFileSystemURL(dirName, callback, fail);
        });
      }
    }, {
      key: "transfrom",
      value: function transfrom(arr) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'baidu';
        // BD09 => GCJ-02 ---
        return new Promise(function (reslove, reject) {
          AMap.convertFrom(arr, type, function (info, result) {
            if (result.info === 'ok') {
              reslove(result.locations[0]);
            } else {
              reslove(null);
            }
          });
        });
      }
    }, {
      key: "antiAddress",
      value: function antiAddress(arr) {
        return new Promise(function (reslove, reject) {
          AMap.plugin('AMap.Geocoder', function () {
            var geocoder = new AMap.Geocoder();
            var lnglat = arr;
            geocoder.getAddress(lnglat, function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                reslove(result.regeocode.formattedAddress);
              } else {
                reslove('');
              }
            });
          });
        });
      }
    }, {
      key: "getLocation",
      value: function getLocation(_ref7) {
        var _this3 = this;

        var coordinate = _ref7.coordinate,
            onSuccess = _ref7.onSuccess,
            onFail = _ref7.onFail;

        var success = /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(back) {
            var longitude, latitude, addr, locationDescribe, citycode, address;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    longitude = back.longitude, latitude = back.latitude, addr = back.addr, locationDescribe = back.locationDescribe, citycode = back.citycode;
                    console.log(back);

                    if (!(coordinate === 1)) {
                      _context.next = 15;
                      break;
                    }

                    address = '';

                    if (!(!addr || !locationDescribe)) {
                      _context.next = 11;
                      break;
                    }

                    _context.next = 8;
                    return _this3.antiAddress([longitude, latitude]);

                  case 8:
                    address = _context.sent;
                    _context.next = 12;
                    break;

                  case 11:
                    addr + locationDescribe;

                  case 12:
                    onSuccess({
                      longitude: longitude,
                      latitude: latitude,
                      address: address,
                      citycode: citycode
                    });
                    _context.next = 16;
                    break;

                  case 15:
                    onSuccess({
                      longitude: longitude,
                      latitude: latitude
                    });

                  case 16:
                    _context.next = 21;
                    break;

                  case 18:
                    _context.prev = 18;
                    _context.t0 = _context["catch"](0);
                    onFail(_context.t0);

                  case 21:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 18]]);
          }));

          return function success(_x) {
            return _ref8.apply(this, arguments);
          };
        }();

        baidumap_location.getCurrentPosition(success, onFail);
      }
    }, {
      key: "versionGet",
      value: function versionGet() {
        return new Promise(function (reslove, reject) {
          cordova.getAppVersion.getVersionNumber().then(function (res) {
            reslove(res);
          }).catch(function (e) {
            return reject(e);
          });
        });
      }
    }, {
      key: "versionUpdate",
      value: function versionUpdate(options) {
        var _this4 = this;

        return new Promise(function (reslove, reject) {
          if (_this4.platform === 'iOS') {
            window.plugins.launcher.launch({
              uri: 'itms-apps://apps.apple.com/cn/app/%E6%99%BA%E6%9C%8D%E4%BA%91/id1524263223'
            }, function (e) {
              return reslove(e);
            }, function (e) {
              return reject(e);
            });
          } else {
            options.dir = cordova.file.externalDataDirectory;

            _this4.download(options).then(function (entry) {
              var url = entry.toURL();
              var fileMIMEType = 'application/vnd.android.package-archive';
              cordova.plugins.fileOpener2.open(url, fileMIMEType, {
                error: function error(e) {
                  reject(e);
                },
                success: function success(e) {
                  reslove(e);
                }
              });
            });
          }
        });
      }
    }, {
      key: "ready",
      value: function ready(fn) {
        document.addEventListener('deviceready', fn, false);
      }
    }]);

    return Devices;
  }();

  var JpushClass = /*#__PURE__*/function () {
    function JpushClass() {
      _classCallCheck(this, JpushClass);

      _defineProperty(this, "debugger", true);

      window.JPush && this.initJpush();
    }

    _createClass(JpushClass, [{
      key: "initJpush",
      value: function initJpush() {
        window.JPush.init();
        window.JPush.setDebugMode(this.debugger);
        this.openNotification();
      }
    }, {
      key: "openNotification",
      value: function openNotification() {
        document.addEventListener('jpush.openNotification', function (event) {
          var alertContent;

          if (device.platform == 'Android') {
            alertContent = event;
          } else {
            alertContent = event.aps;
          } // 应用跳转


          if (alertContent.extras) {
            var route = {
              1: 'OrderDetail',
              2: 'SparepartExamineDetail'
            };
            var obj = {
              name: route[alertContent.extras.messageType],
              params: alertContent.extras
            };
            router.push(obj);
          }
        }, false);
      }
    }, {
      key: "isOpenJpush",
      value: function isOpenJpush() {
        return new Promise(function (reslove, reject) {
          window.JPush.getUserNotificationSettings(function (result) {
            if (result == 0) {
              reslove(true); // 开启
            } else {
              reslove(false); // 关闭
            }
          });
        });
      }
    }, {
      key: "isInitJpush",
      value: function isInitJpush() {
        return new Promise(function (reslove, reject) {
          window.JPush.isPushStopped(function (result) {
            if (result == 0) {
              reslove(true); // 开启
            } else {
              reslove(false); // 关闭
            }
          });
        });
      }
    }, {
      key: "getJpushId",
      value: function getJpushId() {
        return new Promise(function (reslove, reject) {
          window.JPush.getRegistrationID(function (rId) {
            reslove(rId);
          });
        });
      }
    }, {
      key: "setAlias",
      value: function setAlias(_ref9) {
        var sequence = _ref9.sequence,
            alias = _ref9.alias;
        return new Promise(function (reslove, reject) {
          window.JPush.setAlias({
            sequence: sequence,
            alias: alias
          }, function (result) {
            reslove(result);
          }, function (error) {
            reject(error);
          });
        });
      }
    }, {
      key: "getAlias",
      value: function getAlias(_ref10) {
        var sequence = _ref10.sequence;
        return new Promise(function (reslove, reject) {
          window.JPush.getAlias({
            sequence: sequence
          }, function (result) {
            reslove(result);
          }, function (error) {
            reslove({
              alias: ''
            });
          });
        });
      }
    }, {
      key: "initAlias",
      value: function initAlias(alias) {
        var _this5 = this;

        this.getAlias({
          sequence: 1
        }).then(function (res) {
          if (res.alias !== alias) {
            return _this5.setAlias({
              sequence: 1,
              alias: alias
            });
          }
        }).then(function (res) {
          return console.log(res);
        }).catch(function (e) {
          return console.log(e);
        });
      }
    }]);

    return JpushClass;
  }();

  var Util = /*#__PURE__*/function () {
    function Util() {
      _classCallCheck(this, Util);
    }

    _createClass(Util, [{
      key: "share",
      value: function share(_ref11) {
        var type = _ref11.type,
            url = _ref11.url,
            title = _ref11.title,
            content = _ref11.content,
            image = _ref11.image,
            _ref11$wx = _ref11.wx,
            wx = _ref11$wx === void 0 ? 'TIMELINE' : _ref11$wx;
        return new Promise(function (resolve, reject) {
          // 分享类型:1 = weixin ;2 =  dingding
          if (type === 1) {
            // 检查微信安装+
            Wechat.isInstalled(function (installed) {
              !installed && reject('未安装微信');
            }, function (reason) {
              reject(reason);
            }); // 分享的场景 TIMELINE朋友圈 SESSION会话 FAVORITE 收藏 默认朋友圈

            Wechat.share({
              message: {
                title: title,
                description: content,
                thumb: image,
                media: {
                  type: Wechat.Type.WEBPAGE,
                  webpageUrl: url
                }
              },
              scene: Wechat.Scene[wx]
            }, function () {
              resolve();
            }, function (reason) {
              reject(reason);
            });
          }
        });
      }
    }, {
      key: "scan",
      value: function scan(_ref12) {
        var tips = _ref12.tips,
            onSuccess = _ref12.onSuccess,
            onFail = _ref12.onFail;
        // type为qrCode(二维码)、barCode(条形码)、all(全部)
        return new Promise(function (resolve, reject) {
          var qrOptions = Object.assign({
            preferFrontCamera: false,
            // iOS and Android
            showFlipCameraButton: false,
            // iOS and Android
            showTorchButton: true,
            // iOS and Android
            torchOn: false,
            // Android, launch with the torch switched on (if available)
            saveHistory: false,
            // Android, save scan history (default false)
            prompt: '二维码扫描',
            // Android
            resultDisplayDuration: 1500,
            // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
            // formats: 'QR_CODE,PDF_417', // default: all but PDF_417 and RSS_EXPANDED
            orientation: 'portrait',
            // Android only (portrait|landscape), default unset so it rotates with the device
            disableAnimations: false,
            // iOS
            disableSuccessBeep: false // iOS and Android

          }, {
            prompt: tips
          });

          function success(res) {
            onSuccess(res);
            resolve(res);
          }

          function fail(err) {
            onFail(err);
            reject(err);
          }

          cordova.plugins.barcodeScanner.scan(success, fail, qrOptions);
        });
      }
    }, {
      key: "openLink",
      value: function openLink(_ref13) {
        var url = _ref13.url,
            onSuccess = _ref13.onSuccess,
            onFail = _ref13.onFail;
        var ref = cordova.InAppBrowser.open(url, '_blank');
        ref.addEventListener('loadstop', onSuccess);
        ref.addEventListener('loaderror', onFail);
      }
    }, {
      key: "uploadImageFromCamera",
      value: function uploadImageFromCamera(_ref14) {
        var _this6 = this;

        var upLoadUrl = _ref14.upLoadUrl,
            compression = _ref14.compression,
            max = _ref14.max,
            processCallBack = _ref14.processCallBack,
            onSuccess = _ref14.onSuccess,
            onFail = _ref14.onFail;
        this.camera('camera', {
          compression: compression,
          max: max
        }).then(function (res) {
          if (typeof res === 'string') {
            _this6.upload(res, upLoadUrl, processCallBack, onSuccess, onFail);
          } else {
            var arr = res.images.map(function (v) {
              return _this6.upload(v.path, upLoadUrl, processCallBack, onSuccess, onFail);
            });
            Promise.all(arr);
          }
        });
      }
    }, {
      key: "uploadImage",
      value: function uploadImage(_ref15) {
        var _this7 = this;

        var upLoadUrl = _ref15.upLoadUrl,
            compression = _ref15.compression,
            max = _ref15.max,
            processCallBack = _ref15.processCallBack,
            onSuccess = _ref15.onSuccess,
            onFail = _ref15.onFail;
        this.camera('all', {
          compression: compression,
          max: max
        }).then(function (res) {
          console.log(res);

          if (typeof res === 'string') {
            _this7.upload(res, upLoadUrl, processCallBack, onSuccess, onFail);
          } else {
            var arr = res.images.map(function (v) {
              return _this7.upload(v.path, upLoadUrl, processCallBack, onSuccess, onFail);
            });
            Promise.all(arr).catch(function (e) {
              return console.log(e);
            });
          }
        });
      }
    }, {
      key: "camera",
      value: function camera() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'camera';

        var _ref16 = arguments.length > 1 ? arguments[1] : undefined,
            compression = _ref16.compression,
            max = _ref16.max;

        return new Promise(function (reslove, reject) {
          var obj = {
            camera: Camera.PictureSourceType.CAMERA,
            // 1
            library: Camera.PictureSourceType.PHOTOLIBRARY,
            // 0
            album: Camera.PictureSourceType.SAVEDPHOTOALBUM // 2

          };

          var onSuccess = function onSuccess(imageURI) {
            reslove(imageURI);
          };

          var onFail = function onFail(e) {
            reject(e);
          };

          if (type === 'camera') {
            var cameraOptions = {
              quality: compression ? 50 : 100,
              // 质量
              destinationType: Camera.DestinationType.FILE_URI,
              // 保存类型
              sourceType: obj[type],
              // 照相机类型
              allowEdit: false,
              // 编辑
              encodingType: Camera.EncodingType.JPEG,
              // 格式
              saveToPhotoAlbum: false // 本地保存

            };
            navigator.camera.getPicture(onSuccess, onFail, cameraOptions);
          } else {
            ImagePicker.getPictures(onSuccess, onFail, {
              maximumImagesCount: max || 9,
              width: 1920,
              height: 1440,
              quality: compression ? 50 : 100 // 质量

            });
          }
        }).catch(function (e) {
          return console.log(e);
        });
      }
    }, {
      key: "upload",
      value: function upload(fileURL) {
        var upLoadUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : require('../../_target').upTarget;
        var processCallBack = arguments.length > 2 ? arguments[2] : undefined;
        var onSuccess = arguments.length > 3 ? arguments[3] : undefined;
        var onFail = arguments.length > 4 ? arguments[4] : undefined;
        return new Promise(function (reslove, reject) {
          var options = new FileUploadOptions();
          options.fileKey = 'file';
          options.fileName = fileURL.substr(fileURL.lastIndexOf('/') + 1);
          var token = JSON.parse(localStorage.getItem('[smy-vux] - appStore/sessionID'));
          options.headers = {
            token: token
          };
          options.params = {};
          var ft = new FileTransfer();

          ft.onprogress = function (progressEvent) {
            if (progressEvent.lengthComputable && processCallBack) {
              processCallBack(progressEvent.loaded / progressEvent.total * 100);
            }
          };

          var success = function success(result) {
            var obj = JSON.parse(result.response).data;
            var url = obj.fileUrl + obj.files;
            return onSuccess(url);
          };

          ft.upload(fileURL, encodeURI(upLoadUrl), success, onFail, options);
        });
      }
    }]);

    return Util;
  }();

  var MapLocation = /*#__PURE__*/function () {
    function MapLocation() {
      _classCallCheck(this, MapLocation);
    }

    _createClass(MapLocation, [{
      key: "openScheme",
      value: function openScheme(_ref17) {
        var key = _ref17.key,
            lat = _ref17.lat,
            lon = _ref17.lon,
            name = _ref17.name;
        return new Promise(function (reslove, reject) {
          // 坐标转换
          if (key.label === '百度地图') {
            var params = {
              params: {
                key: 'a6b6ecf93b561155535fb94d2d5bacd1',
                locations: lon + ',' + lat,
                coordsys: 'gps'
              }
            };
            axios.get('https://restapi.amap.com/v3/assistant/coordinate/convert', params).then(function (_ref18) {
              var data = _ref18.data;

              if (+data.status === 1) {
                ;

                var _data$locations$split = data.locations.split(',');

                var _data$locations$split2 = _slicedToArray(_data$locations$split, 2);

                lon = _data$locations$split2[0];
                lat = _data$locations$split2[1];
              } else {
                console.error(data.info);
              }

              createView({
                lat: lat,
                lon: lon,
                name: name,
                key: key
              });
            });
          } else {
            createView({
              lat: lat,
              lon: lon,
              name: name,
              key: key
            });
          }

          function createView(_ref19) {
            var lat = _ref19.lat,
                lon = _ref19.lon,
                name = _ref19.name,
                key = _ref19.key;
            var map = [{
              text: '苹果地图',
              url: "http://maps.apple.com/?sll=".concat(lat, ",").concat(lon, "&address=").concat(name),
              run: 'ios'
            }, {
              text: '高德地图',
              url: "iosamap://navi?sourceApplication=applicationName&poiname=".concat(name, "&lat=").concat(lat, "&lon=").concat(lon, "&dev=1"),
              run: 'ios'
            }, {
              text: '百度地图',
              url: "baidumap://map/navi?location=".concat(lat, ",").concat(lon, "&title=").concat(name, "&src=webapp.marker.yourCompanyName.yourAppName"),
              run: 'ios'
            }, {
              text: '高德地图',
              url: "androidamap://navi?sourceApplication=appname&poiname=".concat(name, "&lat=").concat(lat, "&lon=").concat(lon, "&dev=1"),
              run: 'Android'
            }, {
              text: '百度地图',
              url: "bdapp://map/navi?location=".concat(lat, ",").concat(lon, "&query=").concat(name, "&src=andr.baidu.openAPIdemo"),
              run: 'Android'
            }];
            var targetUrl = encodeURI(map.find(function (v) {
              return v.text === key.label && v.run === key.run;
            }).url);
            window.plugins.launcher.launch({
              uri: targetUrl
            }, function (e) {
              return reslove(e);
            }, function (e) {
              return reject(e);
            });
          }
        });
      }
    }, {
      key: "view",
      value: function view(obj) {
        router.push({
          name: 'Mapview',
          query: obj
        });
      }
    }]);

    return MapLocation;
  }();

  window.devices = new Devices();
})(window, document);

export default devices;